import { Colors } from '~/themes/colors';

export const ChevronRight = ({
  size = 24,
  color = Colors.secondary_500,
}: {
  size?: number;
  color?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.35147 18.8486C7.88284 18.3799 7.88284 17.6202 8.35147 17.1515L13.5029 12.0001L8.35147 6.84858C7.88284 6.37995 7.88284 5.62015 8.35147 5.15152C8.8201 4.68289 9.5799 4.68289 10.0485 5.15152L16.0485 11.1515C16.5172 11.6202 16.5172 12.3799 16.0485 12.8486L10.0485 18.8486C9.5799 19.3172 8.8201 19.3172 8.35147 18.8486Z"
        fill={color}
      />
    </svg>
  );
};
